import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import ListaTurmasLayer from "../components/ListaTurmasLayer";
import { useTranslation } from "../i18n/I18nContext";

const ListaTurmasPage = () => {
  const { t } = useTranslation();
  return (
    <MasterLayout>
      <Breadcrumb title={t("turma.breadcrumb.list")} />
      <ListaTurmasLayer />
    </MasterLayout>
  );
};

export default ListaTurmasPage;
